import React from 'react'
import {Link} from 'react-router-dom'
import './styles/Start.css'

class Start extends React.Component{
	constructor(props) {
		super(props);
	}

	shouldComponentUpdate() {
		return false
	}

	render(){
		const { content } = this.props
		const startProjects = content.art.filter((p)=>{return p.aufStartseite=== "1"}).concat(content.com.filter((p)=>{return p.aufStartseite=== "1"}))
		const startProject = startProjects[Math.floor((Math.random() * startProjects.length))]

		const sect = ( startProject.section === 'artWorks' ? 'art' : 'com')

		return(
			<Link to={'/'+sect+'/'+startProject.slug}>
				<div className="Start" >
					<img src={startProject.vorschaubild.hdURL} alt={startProject.vorschaubild.title}/>
				</div>
			</Link>
		)
	}

}

export default Start


// WEBPACK FOOTER //
// ./src/Start.js